<template>
<div class="row">
  <div class="col-md-2">
    <div class="sidebar-menu">
        <h6 class="mb15">TOPICS</h6>
        <div @click="changeRoute(routeNames.introRoute)">
          <div class="pointer router-link" :class="routeNames.activeTabName === routeNames.introRoute ? 'active' : ''">Getting Started 
            <i class="menu-icon intro" :class="routeNames.activeTabName === routeNames.introRoute ? 'fas fa-circle' : ''"></i>
          </div>
        </div>
        <div @click="changeRoute(routeNames.usageRoute)">
          <div class="pointer router-link usage" :class="routeNames.activeTabName === routeNames.usageRoute ? 'active' : ''">Usage 
            <i class="menu-icon" :class="routeNames.activeTabName === routeNames.usageRoute ? 'fas fa-circle' : ''"></i>
          </div>
        </div>
        <div @click="changeRoute(routeNames.searchRoute)">
          <div class="pointer router-link search" :class="routeNames.activeTabName === routeNames.searchRoute ? 'active' : ''">Search 
              <i class="menu-icon" :class="routeNames.activeTabName === routeNames.searchRoute ? 'fas fa-circle' : ''"></i>
          </div>
        </div>                            
        <div @click="changeRoute(routeNames.webhooksRoute)">
          <div class="pointer router-link webhooks" :class="routeNames.activeTabName === routeNames.webhooksRoute ? 'active' : ''">Webhooks 
            <i class="menu-icon" :class="routeNames.activeTabName === routeNames.webhooksRoute ? 'fas fa-circle' : ''"></i>
          </div>
        </div>
        <div class="pointer router-link swagger" target="_blank" @click="sendToSwagger()">To Swagger</div>
    </div>

  </div>
  <div class="col-md-10 content">
    <router-view/>
    <div class="col-md-12 text-center">
        <div class="mt20"><small>&copy;CINC {{new Date().getFullYear()}}</small></div>
    </div>
  </div>
    
</div>
</template>

<style lang="scss">
 @import '../style/component/documentation.scss';
</style>

<script lang="ts">
import { defineComponent } from 'vue'
import { Config } from "../models/Config";

export default defineComponent({
  name: "Documentation",
  setup() {
    const config: Config = require("../../config.json");
    let swaggerUrl = "";
    const routeNames: any = {
      activeTabName: '/docs/intro',
      introRoute: '/docs/intro',
      searchRoute: '/docs/search',
      usageRoute: '/docs/usage',
      webhooksRoute: '/docs/webhooks',
    };
    return {
      routeNames, swaggerUrl, config
    }
  },
  beforeMount() {
      this.swaggerUrl = this.config.apiUrl;
      if (window.location.pathname === '/docs') {
        this.routeNames.activeTabName = this.routeNames.introRoute;
        this.$router.push(this.routeNames.activeTabName);
      }
      else
        this.routeNames.activeTabName = window.location.pathname;
  },
  methods: {
    changeRoute(routeName: string) {
      if (this.routeNames.activeTabName === routeName) {
        return
      }
      else {
        this.routeNames.activeTabName = routeName;
        this.$router.push(routeName);
      }
    },
    sendToSwagger() {
      window.open(this.swaggerUrl, '_blank');
    }
  }
})
</script>
